require('./components/polyfills');
import Filter from './components/Filter';
import List from './components/List';
import MobileFilter from './components/MobileFilter';

if (!window.jQuery) {
	let $ = require('jquery');
	// Add in globally accessible aliases (w/o another JS, like slick, might not get access to $)
	window.jQuery = $;
	window.$ = $;
}

(function() {

	if (window.DLC) {
		const filterContainer = document.querySelector('.js-dc-filter-container');
		const resultsContainer = document.querySelector('.js-dc-result-list'); // exists for list and filter
		if (filterContainer && resultsContainer) {
			const filter = new Filter(DLC, { container: filterContainer, resultsContainer });
		}

		const listContainer = document.querySelector('.js-dc-list-container');
		if (listContainer) {
			const list = new List(DLC, { container: listContainer, resultsContainer });
		}
	}

	let dcMobileFilters = [];
	Array.prototype.slice.call(document.querySelectorAll('.js-dc-mobileFilter')).forEach(filter => {
		dcMobileFilters.push(new MobileFilter(filter, {}));
	});

})();